import validator from 'validator';
import i18n from "shared/i18n";

const validate = values => {
  const errors = {};

  if (!values.url) {
    errors.url = i18n.t("URL should not be empty");
  }

  if (values.url && !validator.isURL(values.url, { allow_underscores: true })) {
    errors.url = i18n.t("Please enter a valid URL");
  }

  return errors;
};

export default validate;
